import React from 'react'

import StatusLightWithLabel from '../../../components/Status/StatusLightWithLabel'

import { UsageUnitLockPeriodStatusMap } from '../../../constants/colorMap'
import { usageUnitLockPeriodStatusLabelValueGetter } from '../valueGetter'
import { useTranslation } from 'react-i18next'

export default React.forwardRef((props, ref) => {
  const { value } = props
  const { t } = useTranslation()

  // src: https://www.ag-grid.com/documentation/react/fine-tuning/#styling-a-react-component
  React.useImperativeHandle(ref, () => ({
    getReactContainerStyle() {
      return {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      }
    },
  }))

  return (
    <StatusLightWithLabel
      status={UsageUnitLockPeriodStatusMap[value]}
      label={t(usageUnitLockPeriodStatusLabelValueGetter(props))}
    />
  )
})
